import { buildLocaleRecord, Locales } from "@simplyk/common";
import { i18n } from "i18next";

const dashboardLabelLanguages = buildLocaleRecord({
  [Locales.EN]: "en",
  [Locales.FR]: "fr",
  [Locales.DE]: "de",
  [Locales.ES]: "en",
});

export const getTranslationLabelLanguage = (locale?: Locales) => locale && dashboardLabelLanguages[locale];

export const loadTranslationLabels = async (instance: i18n, locales: Locales[], signal?: AbortSignal) => {
  const languages = [...new Set(locales.map((locale) => dashboardLabelLanguages[locale]))];
  await Promise.all(
    languages.map(async (language) => {
      if (instance.hasResourceBundle(language, "dashboard")) {
        return;
      }
      const response = await fetch(`/locales/${language}/dashboard.json`, { signal });
      if (!response.ok) {
        throw new Error(`Unable to load ${language} translation labels (${response.status})`);
      }
      const labels: unknown = await response.json();
      if (
        typeof labels !== "object" ||
        labels === null ||
        Array.isArray(labels) ||
        Object.values(labels).some((value: unknown) => typeof value !== "string")
      ) {
        throw new Error(`Invalid ${language} translation labels`);
      }
      instance.addResourceBundle(language, "dashboard", labels, true, true);
    })
  );
  return true;
};
